import { render, staticRenderFns } from "./rengong.vue?vue&type=template&id=57a01a84&scoped=true"
import script from "./rengong.vue?vue&type=script&lang=js"
export * from "./rengong.vue?vue&type=script&lang=js"
import style0 from "./rengong.vue?vue&type=style&index=0&id=57a01a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a01a84",
  null
  
)

export default component.exports